export default function formatNumberString(
	input: string,
	locale = "en-GB",
): string {
	// 1. A prefix with non-digit characters
	// 2. A numeric part that can be integer or decimal
	// 3. A suffix with non-digit characters
	const match = input.match(/^(\D*)(\d+(?:\.\d+)?)(\D*)$/);
	if (!match) {
		return input;
	}

	const [, prefix, numberStr, suffix] = match;

	// Determine the number of digits after the decimal point (if any)
	let fractionDigits = 0;
	const decimalMatch = numberStr.match(/\.(\d+)/);
	if (decimalMatch) {
		fractionDigits = decimalMatch[1].length;
	}

	const num = Number(numberStr);

	// Format the number with thousands separators and preserve the decimals
	const formattedNumber = new Intl.NumberFormat(locale, {
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits,
	}).format(num);

	return `${prefix}${formattedNumber}${suffix}`;
}
